angular.
module("dx.webapp.jobs").
factory("DxJob", function jobFactoryService(
	dxLocalize,
	DX_JOB_STATUS,
	DX_JOB_TYPE
) {
	"use strict";

	return function Job(data) {
		if (!(this instanceof Job)) {
			throw new Error("Constructor must be called with 'new'.");
		}

		angular.extend(this, {
			id: 0,
			type: "",
			status: "",
			userId: 0,
			messages: [],
			friendlyDescription: "",
			taskCountTotal: 0,
			taskCountDone: 0,
			taskCountSkipped: 0,
			taskQueueName: "",
			bucketPath: "",
			bucketName: "",
			project: "",
			created: new Date(),
			modified: new Date(),
			deleted: false,
			archived: false,
			organizationId: 0,
		});

		if (data) {
			angular.extend(this, data);
		}

		this.getStatus = function getStatus() {
			switch (this.status) {
				case DX_JOB_STATUS.CREATED:
					return dxLocalize.get("Jobs.Status.Created");
				case DX_JOB_STATUS.RUNNING:
					return dxLocalize.get("Jobs.Status.Running");
				case DX_JOB_STATUS.DONE:
					return dxLocalize.get("Jobs.Status.Done");
				default:
					return dxLocalize.get("Jobs.Status.Error");
			}
		};

		this.getType = function getType() {
			if (this.type === DX_JOB_TYPE.IMPORT_STUDENT_DATA) {
				return dxLocalize.get("Jobs.StudentImport");
			}
			return this.type;
		};

		this.getSuccessfulCount = function getSuccessfulCount() {
			return this.taskCountDone - this.taskCountSkipped;
		};
	};
});
